<template>
    <div id="save-offer-modal"
         class="modal fade renewal-check-modal"
         data-bs-keyboard="false"
         tabindex="-1"
         aria-labelledby="renewalCheckModalLabel"
         aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="renewalCheckModalLabel">
                        Bekijk hier jouw persoonlijke korting.
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <loader
                        :loading="loading"
                        text="De einddatum van jouw abonnement word opgezocht. Een moment geduld alsjeblieft."
                    />

                    <div v-if="hasError" class="alert alert-danger mb-0">
                        Op dit moment krijgen wij geen inzicht in de datum waarop je bij kunt verlengen.
                        Je kunt, indien je dat wenst, wel gewoon een bestelling plaatsen. De bestelling lukt als een
                        verlenging of overstap met nummerbehoud mogelijk is. Indien dat nog niet kan,
                        ontvangen wij de einddatum van jouw contract. Die laten we aan je weten.
                    </div>

                    <div v-if="hasSuccess" class="alert alert-success mb-0">
                        Goed nieuws, je kunt direct verlengen.
                    </div>

                    <div class="renewal-check-form-wrapper">
                        <div class="information-section">
                            <p class="mb-3">
                                Als jouw mobiele contract vrij is, kun je overstappen of verlengen. Je krijgt dan vaak grote korting op je nieuwe smartphone en abonnement
                            </p>

                            <p>
                                Als jouw mobiele contract vrij is, kun je overstappen of verlengen. Je krijgt dan vaak grote korting op je nieuwe smartphone en abonnement
                            </p>
                        </div>

                        <form class="form">
                            <div class="container-fluid">

                                <div class="form-content-wrap">
                                    <div class="form-group mb-3">
                                        <label for="phone">Mobiel nummer</label>
                                        <input
                                            v-model="customer.phone_number"
                                            id="phone" type="tel"
                                            name="phone" class="form-control"
                                            max="10"
                                            placeholder="Mobiel nummer"
                                            required
                                        >
                                    </div>

                                    <div class="form-group mb-3">
                                        <label for="birth_date">Geboortedatum</label>
                                        <input
                                            v-model="customer.birth_date"
                                            v-maska
                                            data-maska="##-##-####"
                                            id="birth_date"
                                            placeholder="Geboortedatum"
                                            class="form-control"
                                            required
                                        />
                                    </div>

                                    <div class="row">
                                        <div class="col-12 col-md-6">
                                            <div class="form-group">
                                                <label for="postal-code">Postcode</label>
                                                <input
                                                    v-model="customer.postal_code"
                                                    id="postal-code" type="text"
                                                    name="postal_code" class="form-control"
                                                    placeholder="Postcode" pattern="[0-9]{4}\s?[a-zA-Z]{2}"
                                                    size="7" maxlength="7" required
                                                >
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-6">
                                            <div class="form-group mb-3">
                                                <label for="house-number">Huisnummer (zonder toevoeging)</label>
                                                <input
                                                    v-model="customer.house_number"
                                                    id="house-number" type="number"
                                                    name="house_number" class="form-control"
                                                    placeholder="Huisnummer" required
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="modal-footer">
                    <button
                        type="submit" class="btn btn-dark btn-renewal-check"
                        @click.prevent="onSubmit"
                        :disabled="loading"
                    >
                        Verstuur
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from '@vueform/multiselect'
import Loader from "../Loader"

export default {
    components: {
        Multiselect,
        Loader
    },

    props: {
        type: {
            type: String,
            default: 'WEBSITE'
        },

    },

    data() {
        return {
            loading: false,
            hasError: false,
            hasSuccess: false,
            customer: {
                phone_number: '',
                birth_date: null,
                postal_code: '',
                password: '',
            },
        }
    },

    methods: {
        async onSubmit() {
            this.hasSuccess = false
            this.hasError = false
            this.loading = true

            // await axios
            //     .get(`/api/save-offer`, {
            //         params: {
            //             ...this.customer,
            //             type: this.type
            //         }
            //     })
            //     .then(({data}) => {
            //         this.hasSuccess = true
            //         this.loading = false
            //     })
            //     .catch(() => {
            //         this.hasError = true
            //         this.loading = false
            //     })
        }
    }
}
</script>
